<template>
  <div class="home_box" id="page0">
   
        <div id="page1" class="home_first">
          <img
            class="home_first_img"
            src="../../../assets/img/pc/HomePage1.png"
            alt=""
          />
          <div class="orientation fade-in-bottom">
            <div class="page1_Text1">美丽、塑形、健康管理</div>
            <div class="page1_Text2">美丽、塑形、健康管理</div>
            <div class="page1_Text3">Beauty, shaping, health management</div>
          </div>
        </div>
        <div id="page2" class="home_first">
          <img
            class="home_first_img"
            src="../../../assets/img/pc/HomePage2.png"
            alt=""
          />
          <div class="orientation2 fade-in-bottom js-scroll">
            <div class="page1_Text1">世界级生物技术</div>
            <div class="page1_Text2">
              <div>采用世界级 D2P 技术</div>
              <div>深耕无细胞合成蛋白领域多年</div>
              <div>拥有多款国内外畅销产品</div>
              <div>数百项专利积累</div>
            </div>
            <div class="page1_Text3">
              <div>Adopt world-class D2P technology</div>
              <div>
                deeply cultivated in the field of cell-free synthetic protein
                for many years
              </div>
              <div>
                have a variety of best-selling products at home and abroad
              </div>
              <div>hundreds of patents accumulated</div>
            </div>
          </div>
        </div>
        <div id="page3" class="home_first">
          <img
            class="home_first_img"
            src="../../../assets/img/pc/HomePage3.png"
            alt=""
          />
          <div class="orientation3 fade-in-bottom js-scroll">
            <div class="page1_Text1">生物活性品质保证</div>
            <div class="page1_Text2">
              <div>注重产品成分可靠、高效的特性，不添加香精、不添加色素、</div>
              <div>不添加防腐剂，生物活肤。</div>
            </div>
            <div class="page1_Text3">
              <div>Pay attention to the reliable and high-efficiency</div>
              <div>
                characteristics of the product ingredients, no added flavor, no
              </div>
              <div>
                coloring, no added preservatives, biologically revitalizing.
              </div>
            </div>
          </div>
        </div>
        <div id="page4"  ref="obtain">
          <div class="page4_box">
            <div class="page4_box_left fade-in-bottom js-scroll">
              <div class="page4_Text1">ABOUT US</div>
              <div class="page4_Text2">关于妍诗美社</div>
              <div class="page4_Text3">
                2021
                年，妍诗美社医美健康品牌正式亮相，致力于打造一流医美健康品牌，帮助更多女性永葆青春。
              </div>
              <div class="page4_Text4">
                成立于海南省三亚市的妍诗美社（海南）医美健康科技有限公司(YSTE (Hainan) Aesthetic Medicine Health Technology Co., Ltd.)，拥有医药级GMP生产质控体系，依托世界级
                D2P
                技术支撑，采用多项全球领先MMLPT新型大分子递送技术，将众多生物活性的蛋白质，多肽等高效透皮进入真皮细胞，实现真正的高效新型功效性高端化妆品的研发制造，推动中国医美产业的高科技化，高功效化，高安全化，以科技为本，引领世界。
              </div>
            </div>
            <div class="page4_box_right js-scroll slide-right">
              <img src="../../../assets/img/pc/experiment.png" alt="" />
            </div>
          </div>
        </div>
    <div id="page5">
      <div class="home_data5">
        <img src="../../../assets/img/pc/bg.png" alt="" />
        <div class="page5_logo">
          <img src="../../../assets/img/pc/logo2.png" alt="" />
        </div>
        <div class="page5_wordage fade-in js-scroll" >
          <div>改善肌底问题</div>
          <div>打造水润透光肌</div>
        </div>
        <div class="page5_exhibition fade-in js-scroll" >
          <div class="page5_exhibition_item">
            <img src="../../../assets/img/pc/repair.png" alt="" />
            <div class="page5_Text1">维稳修复</div>
            <div class="page5_Text2">
              独特生物科技，数十种有机生物大分子，低温保存活性，随取随用，确保抗皱活性不损失，高效滋养皮肤。
            </div>
          </div>
          <div class="page5_sx"></div>
          <div class="page5_exhibition_item">
            <img src="../../../assets/img/pc/moisturized.png" alt="" />
            <div class="page5_Text1">水润光泽</div>
            <div class="page5_Text2">
              四重功效，抗皱、紧致、修护、保湿，重重叠 加， 使祛皱效果最大化
            </div>
          </div>
          <div class="page5_sx"></div>
          <div class="page5_exhibition_item">
            <img src="../../../assets/img/pc/safety.png" alt="" />
            <div class="page5_Text1">安全健康</div>
            <div class="page5_Text2">
              生物医药级产品开发，GMP 级精华生产
              线，排除过敏反应，保护敏感肌肤。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="page6" class="home_data6">
      <div class="home_data6_box fade-in-bottom js-scroll">
        <div class="page6_Text1">普罗敦焕颜抗皱产品家族</div>
      <div class="page6_Text2">紧致轮廓 多效修护保湿</div>
      <div class="page6_Text3">Multi-effect repair and moisturizing</div>
      <div class="page6_Text4">一站式抗老</div>
      <div class="page6_Text5">重回年轻肌肤</div>
      </div>
      <div class="page6_tu">
        <el-row>
          <el-col
            v-for="(item, index) in productPicture"
            :key="index"
            :span="8"
            class="page6_col fade-in js-scroll"
            :class="'page6_col' + item.id"
            ><img class="page6_img" :src="item.url" alt="" />
            <div class="page6_col_Text1 fade-in-bottom js-scroll">{{ item.name }}</div>
            <div class="page6_col_Text2 fade-in-bottom js-scroll">{{ item.particulars }}</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div id="page7" class="home_data7">
      <div class="home_data7_box fade-in js-scroll">
      <img src="../../../assets/img/pc/D2P.png" alt="" />
      </div>
    </div>
    <div id="page8" class="home_data">
      <div class="home_data_addressT">妍诗美社（海南）医美健康科技有限公司</div>
      <div class="home_data_addressT">YSTE (Hainan) Aesthetic Medicine Health Technology Co., Ltd.</div>
      <div class="home_data_addressB">
        公司地址：海南省三亚市崖州湾深海科技城综合中心A2栋
      </div>
      <el-form class="home_chart" :model="Form" :rules="rules" ref="Form">
        <el-form-item class="home_chart_input2" prop="name">
          <el-input
            class="home_chart_input"
            placeholder="Name"
            v-model="Form.name"
          ></el-input>
        </el-form-item>
        <el-form-item class="home_chart_input3" prop="Phone">
          <el-input
            class="home_chart_input"
            placeholder="Phone Number"
            v-model="Form.Phone"
          ></el-input>
        </el-form-item>
        <el-form-item prop="Mail">
          <el-input
            class="home_chart_input"
            placeholder="Mail"
            v-model="Form.Mail"
          ></el-input>
        </el-form-item>

        <el-form-item class="home_chart_input4" prop="Message">
          <el-input
            class="home_chart_input"
            placeholder="Message Content"
            type="textarea"
            v-model="Form.Message"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item class="home_chart_button">
          <el-button class="home_chart_buttonC" type="primary" @click="onSubmit"
            >Submit</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ApplyData } from "../../../api/index";
export default {
  data() {
    var validatorPhone = function (rule, value, callback) {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    var validatorMail = function (rule, value, callback) {
      if (value === "") {
        callback(new Error("邮箱不能为空"));
      } else if (
        !/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(value)
      ) {
        callback(new Error("邮箱格式错误"));
      } else {
        callback();
      }
    };
    return {
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0, // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      startTime: undefined, // 记录触摸开始的时间
      startX: undefined, // 记录触摸开始的X坐标，本次主要实现的是上下滑动，所以当前坐标不做强制要求
      startY: undefined, // 记录触摸开始的Y坐标

      throttleTimer: false,
      Form: {
        name: "",
        Mail: "",
        Phone: "",
        Message: "",
      },
      productPicture: [
        {
          url: require("../../../assets/img/pc/1.png"),
          id: 1,
          name: "普罗敦焕颜抗皱精华",
          particulars: "生物科技 有效抗皱",
        },
        {
          url: require("../../../assets/img/pc/2.png"),
          id: 2,
          name: "普罗敦焕颜抗皱小银管",
          particulars: "柔珠按摩 双效抗皱",
        },
        {
          url: require("../../../assets/img/pc/3.png"),
          id: 3,
          name: "普罗敦水润保湿柔肤水",
          particulars: "面颈部用小柔珠",
        },
        {
          url: require("../../../assets/img/pc/4.png"),
          id: 1,
          name: "普罗敦水润保湿柔肤水",
          particulars: "肢体部大柔珠",
        },
        {
          url: require("../../../assets/img/pc/5.png"),
          id: 2,
          name: "普罗敦低温保存盒（铝制）",
          particulars: "持续低温 保持生物活性",
        },
        {
          url: require("../../../assets/img/pc/6.png"),
          id: 3,
          name: "普罗敦低温保存盒（硅胶）",
          particulars: "持续低温 保持生物活性",
        },
      ],
      rules: {
        name: [{ required: true, message: "请输入Name", trigger: "blur" }],
        Mail: [{ validator: validatorMail, trigger: "blur" }],
        Phone: [{ validator: validatorPhone, trigger: "blur" }],
        Message: [
          { required: true, message: "请输入Message", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    const scrollElements = document.querySelectorAll(".js-scroll");

    // console.log(scrollElements)
    // var PageId = document.querySelector("#page" + key);
    //   window.scrollTo({
    //     top: PageId.offsetTop,
    //     behavior: "smooth",
    //   });
    const displayScrollElement = (element) => {
      element.classList.add("scrolled");
    };
    const elementInView = (el, percentageScroll = 100) => {
      const elementTop = el.getBoundingClientRect().top;
      return (
        elementTop <=
        (window.innerHeight || document.documentElement.clientHeight) *
          (percentageScroll / 100)
      );
    };
    window.addEventListener("scroll", (e) => {
      throttle(handleScrollAnimation, 250);
    });
    const hideScrollElement = (element) => {
      element.classList.remove("scrolled");
    };
    const handleScrollAnimation = () => {
      scrollElements.forEach((el) => {
        if (elementInView(el, 100)) {
          displayScrollElement(el);
        } else {
          hideScrollElement(el);
        }
      });
    };

    const throttle = (callback, time) => {
      if (this.throttleTimer) return; // 这里标记一下，以使函数不会重复执行
      this.throttleTimer = true;
      setTimeout(() => {
        // 到了指定的时间，调用传入的回调函数
        callback();
        this.throttleTimer = false;
      }, time);
    };
  },
  computed: {
    ...mapState({
      scroll: (state) => state.app.scroll,
    }),
  },
  watch: {
    scroll: {
      handler: function (val, oldval) {
        if (val > 0) {
          this.move(val);
        }
      },
      immediate: true, //关键
      deep: true,
    },
  },
  methods: {
    onSubmit() {
      this.$refs.Form.validate((valid) => {
        if (valid) {
          ApplyData({
            userName: this.Form.name,
            userPhone: this.Form.Phone,
            userMail: this.Form.Mail,
            messageContent: this.Form.Message,
          }).then((res) => {
            if (res.resultCode == 200) {
              this.$refs.Form.resetFields();
              this.$message({
                message: "提交成功",
                type: "success",
              });
            } else {
              this.$message({
                message: "提交失败",
                type: "error",
              });
            }
          });
        }
      });
    },
    move(key) {
      var PageId = document.querySelector("#page" + key).offsetTop;
      window.scrollTo({
        top: PageId -100,
        behavior: "smooth",
      });
      //   // PageId.scrollIntoView()
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/pc/home.css";

.home_box {
  width: 100%;
  height: 100%;
  min-width: 1200px;
}
.home_first {
  width: 100%;
  height: 100%;
  position: relative;
}
.home_first_img {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/views/pc/home/index.vue